module.exports = __webpack_public_path__ + "static/media/fly0108.1b45add4.webp";